import BigNumber from 'bignumber.js';

import { NftKeysLeaderboardRow } from '#/api/nft';

import { FormattedValue, Nullable } from '#/utils/types';
import { PollingConnectionBaseState } from '#/utils/usePollingConnection';

export interface NftKeysLeaderboardStore extends PollingConnectionBaseState {
  readonly data: Nullable<NftKeysLeaderboardRow[]>;
}

export interface NftKeysLeaderboardView {
  readonly isLoading: boolean;
  readonly error: string | null;
  readonly data: NftKeysLeaderboardRowView[];
}

export interface NftKeysLeaderboardRowView
  extends Pick<NftKeysLeaderboardRow, 'rank' | 'username' | 'is_user_account'> {
  readonly traded_volume: FormattedValue<Nullable<BigNumber>>;
}

export function createView(
  state: NftKeysLeaderboardStore,
): NftKeysLeaderboardView {
  const isLoading = state.status === 'loading';
  const error = state.error === '' ? null : state.error;
  const data = state.data?.map(rowView) ?? [];
  return {
    isLoading,
    error,
    data,
  };
}

function rowView(row: NftKeysLeaderboardRow): NftKeysLeaderboardRowView {
  return {
    rank: row.rank,
    username: row.username,
    is_user_account: row.is_user_account,
    traded_volume: {
      value: row.traded_volume,
      formatted: row.traded_volume?.toFormat(0) ?? '0',
    },
  };
}
